<template>
    <div
        class="login-page"
        :style="{'background-image': `url(${require('@/assets/login-bg.jpg')})`}">
        <v-card
            width="570"
            outlined>
            <div class="logo-container">
                <img src="@/assets/olaf-logo.png" />
            </div>
            <v-card-text class="card-input">
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation>
                    <v-text-field
                        label="Username"
                        v-model="username"
                        autocomplete="off"
                        placeholder="Enter your username"
                        :rules="usernameRules"
                    ></v-text-field>

                    <v-text-field
                        label="Password"
                        v-model="password"
                        type="password"
                        placeholder="Enter your password"
                        v-on:keyup.enter="onSubmit()"
                        :rules="passwordRules"
                    ></v-text-field>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    class="mx-auto my-5"
                    width="264"
                    color="primary"
                    @click="onSubmit()">
                    Login
                </v-btn>
            </v-card-actions>
        </v-card>

        <div class="version">
            {{ $util.getVersionLabel() }}
        </div>
    </div>
</template>
<script>
export default {

    name: 'login',

    data () {
        return {
            valid: true,
            username: '',
            password: '',
            loading: false,
            usernameRules: [
                v => !!v || 'Name is required'
            ],
            passwordRules: [
                v => !!v || 'Password is required'
            ]
        }
    },

    methods: {
        async onSubmit () {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('setLoading', true)

                const response = await this.axios.post('login', {
                    username: this.username,
                    password: this.password
                })

                if (response && response.data) {
                    localStorage.setItem('jwt', response.data.access)
                    localStorage.setItem('userId', response.data.userId)

                    this.$store.dispatch('setLoading', false)

                    this.$router.push({ name: 'Dashboard' }, () => {})
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.invalid-text {
    color: red;
}
.login-page {
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .v-content {
        height: 100%;
    }
}
.card-input {
    padding: 0rem 5rem;
}
.logo-container {
    display: flex;
    justify-content: center;
    margin: 2rem 0;
}
.version {
    position: fixed;
    right: 12px;
    bottom: 10px;
    font-weight: 400;
    font-size: 12px;
}
</style>
